import React, {useState, useEffect} from 'react'
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import StaffImg1 from '../assets/staff-img1.gif';

const ManageCoupons = () => {
  const [response, setResponse] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [showAdd, setShowAdd] = useState(false);
     const [loading, setLoading] = useState(false);
       const [coupon, setCoupon] = useState([]);
       const [showDelete, setShowDelete] = useState(false);
       const [selectedCoupon, setSelectedCoupon] = useState('');
     const [editMode, setEditMode] = useState(false);
  
  const [newCoupon, setNewCoupon] = useState({
    coupon_name: '',
    coupon_code: '',
    order_value: '',
    discount_type: 'amount',
    discount_amount: '',
  });


  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNewCoupon((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {

    fetchCoupons();
  }, []);


    const fetchCoupons = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-coupon');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();
  const sortedData = data.sort((a, b) => b.id - a.id);
          setCoupon(sortedData);
        } else {
          setLoading(false);
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching staff:', error);
      }
    };


  const handleAddCoupon = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {

        const url = editMode
      ? `https://api.kcmstore.in/store/update-coupon/${selectedCoupon.id}`
      : 'https://api.kcmstore.in/store/add-coupon';

       const method = editMode ? 'PUT' : 'POST';
       
       const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newCoupon),
    });

      setLoading(false);

      if (response.ok) {
           setResponse(editMode ? 'Coupon updated successfully!' : 'Coupon added successfully!');
        setTimeout(() => {
          setResponse('');
          setNewCoupon({ coupon_name: '', coupon_code: '', order_value: '', discount_amount: '' });
          setShowAdd(false);
fetchCoupons();
          // window.location.reload();
        }, 2000);
      } else if (response.status == 400) {
        setLoading(false);
        setResponse('Coupon exists with same Code');
        setTimeout(() => setResponse(''), 2000);
      }
      else {
        setLoading(false);
           setResponse(editMode ? 'Unable to update Coupon.' : 'Unable to add Coupon.');
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error('Error adding Sub Admin:', error);
    }
  };

  const filteredCoupon = coupon.filter(c =>
    (c.coupon_name?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (c.coupon_code?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
  );
  
  const handleRemoveDialog = (c) => {
    setSelectedCoupon(c);
    setShowDelete(true);
  }


  const handleRemove = async (cId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/delete-coupon/${cId}`, {
        method: 'DELETE',
      });

      setLoading(false);

      if (response.ok) {
        setCoupon((prevStaff) => prevStaff.filter((staff) => staff.id !== cId));
        setResponse('Coupon Removed successfully!');
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
        setLoading(false);
        setResponse('Unable to Delete Coupon.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error deleting sub admin:', error);
    }
  };


  const handleEditDialog = (c) => {
  setSelectedCoupon(c);

  setNewCoupon({
    coupon_name: c.coupon_name,
    coupon_code: c.coupon_code,
    order_value: c.order_value,
    discount_type: c.discount_type,
    discount_amount: c.discount_amount,
  });

  setEditMode(true);
  setShowAdd(true);
};

  return (
    <>
          <section className='py-4 bg-light'>
        <div className='px-4'>
          <div className='d-flex'>
            <p className='sec-heading'>Coupons</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Add</span>
          </div>

          <div className='row justify-content-between'>
            <div className='d-flex bg-white rounded-4 col-lg-10 col-md-8 col-sm-7 col-12 my-2'>
              <i class="fa-solid fa-magnifying-glass text-darkblue pt-3 px-3"></i>
              <input
                type="text"
                className="form-input rounded-4 border-0"
                placeholder="Search coupon name, code"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className='col-lg-2 col-md-4 col-sm-5 col-12 my-2 order-lg-last order-md-last order-sm-last order-first'>
              <button className='login-btn2' onClick={() => setShowAdd(true)}>Add Coupon</button></div>

          </div>
{/* search row ends */}

          <div className='row bg-white rounded-4 px-lg-2 py-3 mt-3'>

            {filteredCoupon.length > 0 ? (
              filteredCoupon.map((c) => (
                <div key={c.id} className='col-lg-4 col-md-6 col-sm-6 col-12 my-2 px-2'>
                  <div className='staff-area d-lg-block d-md-block d-sm-block d-flex '>
                    <div className='text-lg-center text-md-center text-sm-center text-start'>
                      <p className='featured-category text-capitalize'>{c.coupon_name}<br />{c.discount_type == 'amount' && '₹'}{c.discount_amount}{c.discount_type == 'percent' && '%'} OFF</p>
<p className='mt-3'><span className='px-4 py-2 coupon-code' >                        {c.coupon_code}</span></p>

                        <p className='my-3 para-text fw-semibold text-muted'>Applicable on Orders with Min. Order Total value ₹{c.order_value}</p>
                      <button className='login-btn me-2' onClick={() => handleEditDialog(c)}>Edit</button>
                      <button className='login-btn' onClick={() => handleRemoveDialog(c)}>Remove</button>
                      </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className='text-center'>
                  <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                  <p className='fw-bold'>No Coupon Added yet.</p>
                </div>
              </>
            )}


          </div>
          {/* row ends */}


</div>
</section>




      {showAdd && (
        <>
          <section className='delete-dialog px-3 py-5'>
            <div className='bg-white col-lg-5 col-md-8 mx-auto px-3 py-3 rounded-4'>

              <p className='sec-heading'>Add New Coupon</p>


              <form class="row g-3 text-start" onSubmit={handleAddCoupon}>
                <div class="col-12">
                  <label for="inputName" class="form-label fw-semibold">Coupon Name</label>
                  <input type="text" class="form-input" id="coupon_name" name='coupon_name' value={newCoupon.coupon_name} onChange={handleInputChange} required />
                </div>
                <div class="col-md-6">
                  <label for="inputPhone" class="form-label fw-semibold">Code</label>
                  <input type="text" maxLength="10" class="form-input" id="coupon_code" name='coupon_code' value={newCoupon.coupon_code} onChange={handleInputChange} required />
                </div>

                                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label fw-semibold">Min. Order Value</label>
                  <input type="text" class="form-input" id="order_value" name='order_value' value={newCoupon.order_value} onChange={handleInputChange} required />
                </div>


                <div className="col-md-6">
                  <label className="form-label fw-semibold" htmlFor="discount_type">Discount Type</label>
                  <select className="form-input" id="discount_type" name='discount_type' value={newCoupon.discount_type} onChange={handleInputChange} required>
                    <option value="amount">Amount</option>
                    <option value="percent">Percent</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label fw-semibold">Amount</label>
                  <input type="text" class="form-input" id="inputPassword4" name='discount_amount' value={newCoupon.discount_amount} onChange={handleInputChange} required />
                </div>


                <div class="col-12 my-3">
                 <button
  className='danger-btn'
  onClick={() => {
    setShowAdd(false);
    setEditMode(false);
    setNewCoupon({
      coupon_name: '',
      coupon_code: '',
      order_value: '',
      discount_type: 'amount',
      discount_amount: '',
    });
  }}
>
  Cancel
</button>&nbsp;&nbsp;
                  <button type="submit" class="success-btn">{editMode ? 'Update': 'Add'}</button>
                </div>
              </form>

            </div>
          </section>
        </>
      )}


            {showDelete && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'>
              <p className='featured-category my-4'>Do you want to remove {selectedCoupon.coupon_name}?</p>
              <button className='success-btn' onClick={() => handleRemove(selectedCoupon.id)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowDelete(false)}>No</button>
            </div>
          </section>
        </>
      )}

      {response && <ResponseMsg message={response} />}
      {loading && <Loading setLoading={setLoading} />}


    </>
  )
}

export default ManageCoupons